angular
	.module 'App.Module.DiscountReasonCode', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'discount_reason_codes',
				url: '/discount_reason_codes'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					"entity_search@discount_reason_codes":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'DiscountReasonCodeSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.DiscountReasonCodes.Enabled'
					searchParams:
						repositoryName: 'ReasonCodeRepository'
						title: 'general.discount.reason.codes'

			.state 'discount_reason_codes.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					discountReasonCode: (ReasonCodeRepository, $stateParams) ->
						return ReasonCodeRepository.getEntity($stateParams.id)

			.state 'discount_reason_codes.edit.details',
				url: '/details'
				views:
					entity_sub_view:
						controller: 'DiscountReasonCodeController'
						controllerAs: 'vm'
						templateUrl: '@app/discount-reason-code/discount-reason-code.view.html'
